var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMailBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.417,
    height: 27.03,
    viewBox: "1275.806 15.834 30.417 27.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon-mail"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 43"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1300.139 29.014c1.48 0 2.859.426 4.055 1.115V17.861a2.034 2.034 0 0 0-2.027-2.027h-24.334a2.034 2.034 0 0 0-2.027 2.027V38.14c0 1.115.912 2.028 2.027 2.028h14.803a7.981 7.981 0 0 1-.608-3.042 8.109 8.109 0 0 1 8.11-8.11Zm-22.306-8.76v-2.393L1290 25.466l12.167-7.605v2.393L1290 27.858l-12.167-7.604Z",
    fill: "#1d679d",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1300.484 31.387-1.44 1.44 3.305 3.284h-8.293v2.028h8.293l-3.305 3.285 1.44 1.44 5.738-5.739-5.738-5.738Z",
    fill: "#1d679d",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 34"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailBig);
export default __webpack_public_path__ + "static/media/icon-mail-big.35c2378110a10774afb409b0deaf0c96.svg";
export { ForwardRef as ReactComponent };